<template>
  <div class="auth-page auth-page--scroll">
    <div class="auth-wrapper auth-v1">
      <div class="auth-inner auth-inner--wide">
        <v-card class="auth-card pa-6">
          <v-card-title class="d-flex align-center justify-center py-7">
            <router-link
              to="/signin"
              class="d-flex align-center"
            >
              <h2 class="text-2xl font-weight-semibold">
                <span class="primary--text">{{ empresaName }}</span>
              </h2>
            </router-link>
          </v-card-title>

          <v-card-text class="text-center">
            <h2 class="mb-2">TERMOS DE USO — LIGDATA</h2>
            <p><strong>Última atualização:</strong> 25 de maio de 2026</p>
          </v-card-text>

          <v-card-text>
            <p>Estes Termos de Uso regulam o acesso e utilização da plataforma Ligdata.</p>

            <h3 class="mt-4 mb-2">1. OBJETO</h3>
            <p>A Ligdata disponibiliza uma plataforma multicanal para envio de SMS, RCS, WhatsApp, Voz/URA, automações, higienização de listas e serviços integrados de comunicação.</p>

            <h3 class="mt-4 mb-2">2. CADASTRO E CONTA</h3>
            <p>O usuário se compromete a fornecer informações verdadeiras, manter seus dados atualizados e proteger suas credenciais de acesso.</p>

            <h3 class="mt-4 mb-2">3. MODELO FINANCEIRO</h3>
            <p>A plataforma opera predominantemente no modelo pré-pago mediante aquisição de créditos.</p>

            <h3 class="mt-4 mb-2">4. REGRAS DE UTILIZAÇÃO</h3>
            <p>É proibido utilizar a plataforma para spam, fraude, phishing, golpes, conteúdos ilegais ou práticas que violem a legislação aplicável.</p>

            <h3 class="mt-4 mb-2">5. RESPONSABILIDADE SOBRE CONTEÚDO</h3>
            <p>O usuário é integralmente responsável pelo conteúdo das campanhas, pela origem dos contatos e pela autorização dos destinatários.</p>

            <h3 class="mt-4 mb-2">6. DISPONIBILIDADE DOS SERVIÇOS</h3>
            <p>A Ligdata buscará manter os serviços disponíveis, porém não garante disponibilidade ininterrupta.</p>

            <h3 class="mt-4 mb-2">7. LIMITAÇÃO DE RESPONSABILIDADE</h3>
            <p>A Ligdata não se responsabiliza por falhas de operadoras, indisponibilidade de terceiros ou rejeição de mensagens.</p>

            <h3 class="mt-4 mb-2">8. SUSPENSÃO E ENCERRAMENTO</h3>
            <p>A Ligdata poderá suspender contas e campanhas em casos de abuso, fraude ou violação destes Termos.</p>

            <h3 class="mt-4 mb-2">9. WHITE-LABEL E REVENDEDORES</h3>
            <p>Clientes white-label e revendedores são responsáveis pelas subcontas vinculadas ao seu ambiente.</p>

            <h3 class="mt-4 mb-2">10. PROGRAMA DE AFILIADOS</h3>
            <p>As regras do programa de afiliados poderão ser alteradas conforme política comercial vigente.</p>

            <h3 class="mt-4 mb-2">11. PROPRIEDADE INTELECTUAL</h3>
            <p>Todo o software, APIs, documentação e tecnologia da Ligdata são protegidos por direitos autorais.</p>

            <h3 class="mt-4 mb-2">12. APIs E INTEGRAÇÕES</h3>
            <p>Usuários que utilizarem APIs devem respeitar limites técnicos e garantir segurança das credenciais.</p>

            <h3 class="mt-4 mb-2">13. ALTERAÇÕES DOS TERMOS</h3>
            <p>Os presentes Termos poderão ser alterados mediante publicação da versão atualizada.</p>

            <h3 class="mt-4 mb-2">14. LEGISLAÇÃO APLICÁVEL</h3>
            <p>Os Termos são regidos pelas leis da República Federativa do Brasil.</p>

            <h3 class="mt-4 mb-2">15. FORO</h3>
            <p>Fica eleito o foro da comarca do domicílio da empresa responsável pela plataforma.</p>
          </v-card-text>

          <v-card-actions class="d-flex justify-center pb-4">
            <v-btn
              color="primary"
              outlined
              @click="$router.push('/signin')"
            >
              Voltar ao Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    empresaName() {
      return process.env.VUE_APP_EMPRESA_ID == 1 ? 'LigData' : 'BetEnvios'
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
